import { Refresh } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import type { FC } from 'react';

interface LoadFailedBlockProps {
  message: string;
  retryLabel: string;
  onRetry: () => void;
}

export const LoadFailedBlock: FC<LoadFailedBlockProps> = ({ message, retryLabel, onRetry }) => (
  <Box display="flex" alignItems="center" gap={1} width="100%">
    <Typography variant="body1" color="error">
      {message}
    </Typography>
    <Button size="small" color="primary" onClick={onRetry} startIcon={<Refresh />}>
      {retryLabel}
    </Button>
  </Box>
);
